import AlertListContainer from '../containers/AlertListContainer'
import DateDisplay, { MONTH_YEAR } from './DateDisplay'
import HighlightContent from './HighlightContent'
import KeywordHighlight from './KeywordHighlight'
import OverlayAboutTile from './OverlayAboutTile'
import OverlayColumn from './OverlayColumn'
import OverlayTagTile from './OverlayTagTile'
import OverlayTile from './OverlayTile'
import OverlayTileColumn from './OverlayTileColumn'
import OverlayTileHeading from './OverlayTileHeading'
import OverlayTileOptionLink from './OverlayTileOptionLink'
import OverlayWorkspaceTile from './OverlayWorkspaceTile'
import PermissionGuard from './PermissionGuard'
import ShareLinkPopover from './ShareLinkPopover'
import WorkspaceSelectorContainer from '../containers/WorkspaceSelectorContainer'
import htmlTruncate from 'html-truncate'
import selectSearchHighlights from '../selectors/selectSearchHighlights'
import _ from 'underscore'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
const { truncate } = _.str

export default class HighlightOverlay extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired,
    highlight: PropTypes.object.isRequired,
    isLiteUser: PropTypes.bool.isRequired,
    metaTags: PropTypes.array.isRequired,
    onAddToWorkspace: PropTypes.func.isRequired,
    owner: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    searchHighlights: PropTypes.array,
    tags: PropTypes.array.isRequired,
    workspaces: PropTypes.array.isRequired
  }

  render() {
    const {
      company,
      highlight,
      isLiteUser,
      metaTags,
      onAddToWorkspace,
      owner,
      permissions,
      searchHighlights,
      tags,
      workspaces
    } = this.props
    const image = highlight.image || {}
    const highlightStories = highlight.highlightStories || []

    const titleHighlights = selectSearchHighlights(searchHighlights, 'name')
    const textHighlights = selectSearchHighlights(searchHighlights, 'text')

    const titleTokens = titleHighlights.reduce((memo, highlight) => {
      return memo.concat(highlight.tokens)
    }, [])
    const textTokens = textHighlights.reduce((memo, highlight) => {
      return memo.concat(highlight.tokens)
    }, [])

    return (
      <div className="insight-overlay-viewer">
        <AlertListContainer clearOnUnmount={true} />
        <OverlayTile className="insight-content">
          <div className="highlight-details-container clearfix">
            <img className="highlight-cover-photo" src={image.tile} />
            <div className="highlight-details">
              <div className="editor-title">
                <KeywordHighlight
                  text={truncate(highlight.name, 135) || I18n.t('No Title')}
                  tokens={titleTokens}
                />
              </div>
              <div className="insight-description">
                <KeywordHighlight
                  text={htmlTruncate(highlight.text || '', 390)}
                  tokens={textTokens}
                />
              </div>
            </div>
          </div>
          <HighlightContent
            highlightStories={highlightStories}
            template={highlight.template || {}}
          />
        </OverlayTile>
        <OverlayColumn align="left">
          <OverlayAboutTile
            date={highlight.insertDt}
            details={{
              'Date Research Occurred': (
                <DateDisplay date={highlight.researchDt} format={MONTH_YEAR} />
              )
            }}
            heading="About this Highlight"
            metaTags={metaTags}
            searchHighlights={titleHighlights}
            title={highlight.name}
            user={owner}
          />
          <OverlayTagTile
            searchHighlights={selectSearchHighlights(
              searchHighlights,
              'tagNames'
            )}
            tags={tags}
          />
        </OverlayColumn>
        <OverlayColumn align="right">
          <OverlayTile className="clearfix">
            <OverlayTileHeading icon="settings" title="Options" />
            <OverlayTileColumn align="left">
              <PermissionGuard
                permissions={permissions}
                object="workspace"
                operation="edit"
              >
                <WorkspaceSelectorContainer
                  onAddToWorkspace={onAddToWorkspace}
                  isLiteUser={isLiteUser}
                >
                  <OverlayTileOptionLink
                    icon="file-add"
                    title="Add To Workspace"
                  />
                </WorkspaceSelectorContainer>
              </PermissionGuard>
            </OverlayTileColumn>
            <OverlayTileColumn align="right">
              {company.canShareFl && (
                <ShareLinkPopover tip={highlight.shareUrl}>
                  <OverlayTileOptionLink title="Share" icon="share" />
                </ShareLinkPopover>
              )}
            </OverlayTileColumn>
          </OverlayTile>
          <OverlayWorkspaceTile workspaces={workspaces} />
        </OverlayColumn>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/HighlightOverlay.js